import { autoinject, transient } from "aurelia-framework";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { EntityValidationsService, ClientSideValidator } from "../../../client-validation-system/validations-service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { UrlHelper } from "../../../helpers/url-helper";
import { UserPasswordPolicy } from "../../../models/authentication/token.models";

@autoinject
@transient()
export class ChangePasswordViewModel {

    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    validator: ClientSideValidator;
    token: string;
    submitting: boolean;
    passwordPolicy: UserPasswordPolicy;

    constructor(private tokenClient: TokenClient,
        private router: Router,
        private i18N: I18N,
        private entityValidationsService: EntityValidationsService,
        private notificationService: NotificationClientService) { }

    activate(params: { token: string }) {
        this.token = params.token;
    }

    attached() {
        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: this.i18N.tr('login-text'),
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: this.i18N.tr('current-password-required-text'),
                parameters: null, property: "currentPassword",
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: this.i18N.tr('new-password-required-text'),
                parameters: null, property: "newPassword",
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: this.i18N.tr('confirm-new-password-required-text'),
                parameters: null, property: "confirmNewPassword",
                validationType: ValidationTypeEnum.Required
            }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
        this.tokenClient.getPasswordPolicy().then(passwordPolicy => {
            this.passwordPolicy = passwordPolicy;
        });
    }

    save() {
        this.submitting = true;
        this.validator.validate().then(x => {
            if (x.valid) {
                const request = {
                    currentPassword: this.currentPassword,
                    newPassword: this.newPassword,
                    confirmNewPassword: this.confirmNewPassword,
                    token: this.token
                }
                this.tokenClient.changePassword(request).then(() => {
                    this.notificationService.show(this.i18N.tr('password-changed-successfully-text'), "", NotificationType.Success);
                    UrlHelper.goToUrlFragment(this.router, '/');
                    this.submitting = false;
                }).catch((exception: { _content: { details: string, meta: any, key: string } }) => {
                    this.submitting = false;
                    this.notificationService.show(this.i18N.tr('change-password-failed-text'), exception._content.details ? exception._content.details : this.i18N.tr('user-cannot-be-saved-text'), NotificationType.Error);
                });
            }
            this.submitting = false;
        });
    }
}
